import React, { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

export interface DashboardImage {
  id: number;
  src: string;
  alt?: string;
}

interface DashboardItemImgProps {
  className?: string;
  images: DashboardImage[];
}

const DashboardItemImg: FunctionComponent<DashboardItemImgProps> = ({
  className,
  images,
}) => {
  const variants = {
    initial: {
      scale: 1,
    },
    animate: {
      scale: 1.1,
      transition: { ease: [0.0, 0.005, 0.2, 1.0] },
    },
    tap: {
      scale: 1.25,
    },
  };

  return (
    <motion.div
      className={className || ''}
      whileHover="animate"
      whileTap="tap"
      initial="initial"
      variants={variants}
    >
      {images.length > 1 && (
        <Image className="behind" src={images[1].src} alt={images[1].alt} />
      )}
      <Image src={images[0]?.src} alt={images[0]?.alt} />
    </motion.div>
  );
};

export default styled(DashboardItemImg)`
  position: relative;
  z-index: 0;
  cursor: pointer;
  ${(props) =>
    props.images.length > 1
      ? css`
          height: 120px;
        `
      : css`
          height: 110px;
        `}

  @media ${({ theme }) => theme.device.tablet} {
    ${(props) =>
      props.images.length > 1
        ? css`
            height: 150px;
          `
        : css`
            height: 140px;
          `}
  }
`;

const Image = styled(motion.img)`
  width: 110px;
  height: 110px;
  object-fit: cover;
  border-radius: 4px;
  overflow: hidden;
  @media ${({ theme }) => theme.device.tablet} {
    width: 140px;
    height: 140px;
  }

  &.behind {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: -1;
    width: 85px;
    height: 85px;

    @media ${({ theme }) => theme.device.tablet} {
      width: 105px;
      height: 105px;
    }
  }
`;
